import React from 'react'
import { UserPermission, UserProfile } from 'commons/types/user'
import {
  CONTENT_MANAGEMENT,
  LIST_PARTICIPANT,
  LIST_PARTICIPATION,
  LIST_RULE,
  LIST_SHARING_MANAGEMENT,
  RESPOND_SHARING,
} from 'commons/constants/permissions'
import ParticipationIcon from '../../../components/Icons/ParticipationIcon'
import RuleIcon from '../../../components/Icons/RuleIcon'
import ApproveIcon from '../../../components/Icons/ApproveIcon'
import PersonsIcon from '../../../components/Icons/PersonsIcon'
import ContentManagementIcon from '../../../components/Icons/ContentManagementIcon'
import ForwardToInboxIcon from '../../../components/Icons/ForwardToInboxIcon'

import gtag from '../gtag'

export type MenuItem = {
  name: string
  path?: string
  disabled?: boolean
  icon: React.ElementType
  permissions?: UserPermission
  profiles?: UserProfile[]
  badge?: number
  setGtagMenu: () => void
}

const menuItems: MenuItem[] = [
  {
    name: 'Agendamentos',
    path: '/participations',
    icon: ParticipationIcon,
    permissions: LIST_PARTICIPATION,
    setGtagMenu: () => gtag('event', 'Botão_menu_Agendamentos'),
  },
  {
    name: 'Aprovação de agendamentos',
    path: '/managerApproval',
    icon: ApproveIcon,
    permissions: RESPOND_SHARING,
    setGtagMenu: () => gtag('event', 'Botão_menu_AprovaçãoDeAgendamentos'),
  },
  {
    name: 'Confirmação de participações',
    path: '/participationConfirmation',
    icon: ApproveIcon,
    setGtagMenu: () => gtag('event', 'Botão_menu_ConfirmaçãoDeParticipações'),
  },
  {
    name: 'Regras de agendamento',
    path: '/rules',
    icon: RuleIcon,
    permissions: LIST_RULE,
    setGtagMenu: () => gtag('event', 'Botão_menu_RegrasDeAgendamento'),
  },
  {
    name: 'Convidados cadastrados',
    path: '/guests',
    icon: PersonsIcon,
    permissions: LIST_PARTICIPANT,
    setGtagMenu: () => gtag('event', 'Botão_menu_ConvidadosCadastrados'),
  },
  {
    name: 'Gerenciamento de Conteúdos',
    path: '/contentManagement',
    icon: ContentManagementIcon,
    permissions: CONTENT_MANAGEMENT,
    setGtagMenu: () => gtag('event', 'Botão_menu_GerenciamentoDeConteúdos'),
  },
  {
    name: 'Gestão de compartilhamento',
    icon: ForwardToInboxIcon,
    path: '/sharingManagement',
    permissions: LIST_SHARING_MANAGEMENT,
    setGtagMenu: () => gtag('event', 'Botão_menu_GestaoCompartilhamento'),
  },
]

export { menuItems }
